import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How fast can you come haul my junk?",
    a: "We offer same-day and next-day pickup across Brevard County. Call us early at (321) 420-2707 for immediate dispatch routing.",
  },
  {
    q: "Do I need to move heavy items to the driveway or curb?",
    a: "No! We are a 100% full-service junk removal company. You don't touch a single thing. We carry items out from bedrooms, attics, backyards, garages, or offices.",
  },
  {
    q: "How is pricing determined?",
    a: "Pricing is based primarily on how much space your items take up in our truck bed. We provide free, upfront quotes before lifting anything.",
  },
  {
    q: "What items do you NOT take?",
    a: "Due to state and county regulations, we cannot haul hazardous chemicals, wet paint, asbestos, biological waste, or industrial fuels.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <h2 className="text-3xl sm:text-5xl font-black uppercase tracking-tighter font-display text-white">
          Frequently Asked Questions
        </h2>
        <p className="text-zinc-400 text-sm mt-2">
          Common questions about scheduling, pricing, and what our Brevard crew can haul.
        </p>
      </div>

      <Accordion type="single" collapsible className="space-y-4">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`faq-${i}`}
            className="rounded-xl bg-zinc-950 border border-zinc-800 px-6 data-[state=open]:border-white/30 transition-colors"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="text-base font-bold text-white uppercase text-left hover:no-underline py-6"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="text-sm text-zinc-400 leading-relaxed pb-6">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
